module.exports = __webpack_public_path__ + "static/7-5991e89ca0b1452591ccc36f989efd86.jpg";